import { fireanalytics } from '@/store/firebase'
import vuetify from '@/plugins/vuetify'

const actions = {
  watch({ commit }, route) {
    route.beforeResolve((to, from, next) => {
      commit('ROUTE_CHANGED', to)
      next()
    })

    route.onReady(() => {
      commit('ROUTE_CHANGED', route.currentRoute)
    })
  },
  toggleSummaries({ commit, rootGetters, rootState }) {
    const reportKey = rootGetters['tools/reportKey']
    const { tools: { displaySavedFilters } } = rootState
    const display = displaySavedFilters[reportKey]
    const newSavedFiltersState = !display
    const payload = { displaySavedFilters: newSavedFiltersState, reportKey }
    const fromMap = {
      true: 'Open',
      false: 'Closed',
    }
    const toMap = {
      false: 'Open',
      true: 'Closed',
    }

    commit('tools/displaySavedFilters', payload, { root: true })

    fireanalytics.event('goal_completion', {
      category: 'Layout',
      description: 'Toggle Saved Filters',
      label: `Toggle Saved Filters from "${fromMap[newSavedFiltersState]}" to "${toMap[newSavedFiltersState]}"`,
    })

    return payload
  },
  navCollapsed({ commit }, navCollapsed) {
    commit('navCollapsed', navCollapsed)
    const fromMap = {
      true: 'Open',
      false: 'Closed',
    }
    const toMap = {
      false: 'Open',
      true: 'Closed',
    }

    fireanalytics.event('goal_completion', {
      category: 'Navigation',
      description: 'Toggle Navigation',
      label: `Toggle Navigation from "${fromMap[navCollapsed]}" to "${toMap[navCollapsed]}"`,
    })
  },
  setDarkMode({ commit, state }, inputDarkMode) {
    const inputValue = typeof inputDarkMode === 'boolean'
    const currentDarkMode = inputValue ? inputDarkMode : !state.darkMode

    commit('darkMode', currentDarkMode)

    // Keep Vuetify and store-driven theme state aligned during startup
    // and sign-in hydration to avoid mixed theme rendering.
    // Sign-in page is now theme-aware and renders correctly in both modes.
    try {
      if (vuetify?.framework?.theme) {
        vuetify.framework.theme.dark = currentDarkMode
      }
    } catch (e) { /* non-browser or vuetify not ready */ }

    // Keep document-level theme class in sync for non-Vuetify elements.
    try {
      if (currentDarkMode) {
        document.documentElement.classList.add('app-theme-dark')
      } else {
        document.documentElement.classList.remove('app-theme-dark')
      }
      document.documentElement.style.backgroundColor = ''
    } catch (e) { /* non-browser environment */ }

    return currentDarkMode
  },
}

export default actions
